module.exports = __webpack_public_path__ + "fonts/manrope-extrabold.046b1d96.woff2";